import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BreakdownDTO} from '../../models/breakdown';
@Component({
  selector: 'app-accounts',
  templateUrl: './breakdowns-details.component.html',
  styleUrls: ['./breakdowns-details.component.css']
})
export class BreakdownsDetailsComponent implements OnInit {
  breakdown: BreakdownDTO;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/breakdowns/breakdowns-details/breakdowns-details.component.ts